module.exports = __webpack_public_path__ + "static/img/examination-result.ff543a5f.png";